module.exports = __webpack_public_path__ + "static/media/angularjs.5f6ff7d1.svg";